import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
const useStyles = makeStyles(theme => ({
  clientReviewTitle: {
    textAlign: "left",
    display: "flex",
    flexDirection: "row"
  },
  radioButton: {
    appearance: "none",
    display: "inline-block",
    width: "18px",
    height: "18px",
    fontSize: "15px",
    cursor: "pointer",
    border: `1px solid ${theme.palette.primary.light}`,
    backgroundColor: "transperant",
    borderRadius: "50%"
  },
  checkedRadioButton: {
    appearance: "auto",
    width: "18px",
    height: "18px",
    accentColor: theme.palette.primary.light,
    cursor: "pointer",
    fontSize: "15px"
  },
  radioGroup: {
    margin: "4px 0px 5px 8px",
    display: "flex",
    cursor: "pointer",
    flexDirection: "row",
    alignItems: "center"
  },
  container: {
    marginBottom: "15px"
  },
  titleIndex: {
    marginRight: "2px"
  },
  title: {
    color: theme.palette.primary.dark,
    marginLeft: "8px"
  }
}));
const RenderQuestion = ({
  index,
  value,
  name,
  onChange,
  options,
  label
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    id: name,
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.clientReviewTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    className: classes.titleIndex
  }, index, "."), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, t(label))), options.map((option, indexRadio) => {
    const isChecked = option.value === value || String(option.value) === String(value);
    return /*#__PURE__*/React.createElement("label", {
      key: indexRadio,
      className: classes.radioGroup
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      value: option.value,
      name: index,
      checked: isChecked,
      className: isChecked ? classes.checkedRadioButton : classes.radioButton,
      onChange: onChange
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.title
    }, t(option.label)));
  }));
};
RenderQuestion.propTypes = {
  index: PropTypes.number,
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.string
};
export default RenderQuestion;